import * as React from 'react';
import { BlockVideo } from '../blocks/BlockVideo';
import ImageJoinSlack from './images/join_slack.png';
import ImageReserveCoaching from './images/reserve_coaching.png';
import ImageStartCourse from './images/start_course.png';
import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';

export const UserTutorialDetailSource = ({ page_key }) => {
    switch (page_key) {
        case UserTutorialCompletionKey.KEY_COMPLETE_TUTORIAL_COURSE:
            return <BlockVideo videoRef={{ provider: 'vimeo', url: 'https://player.vimeo.com/video/473282260' }} />;
        case UserTutorialCompletionKey.KEY_JOIN_SLACK:
            return <img src={ImageJoinSlack} styleName="" />;
        case UserTutorialCompletionKey.KEY_RESERVE_COACHING:
            return <img src={ImageReserveCoaching} styleName="" />;
        case UserTutorialCompletionKey.KEY_START_COURSE:
            return <img src={ImageStartCourse} styleName="" />;
        default:
            return null;
    }
};
